<template>
  <header class="navbar is-primary is-fixed-top has-shadow">
    <div class="navbar-brand">
      <RouterLink
        class="navbar-item"
        :to="{ name: 'Home' }"
      >
        <img
          v-if="$store.getters['ui/authLogo']"
          alt="company logo"
          :src="$store.getters['ui/authLogo']"
        >
        <h4
          v-else
          class="title is-4"
        >
          machete
        </h4>
      </RouterLink>

      <a
        role="button"
        class="navbar-burger burger"
        aria-label="menu"
        aria-expanded="false"
        data-target="navbar-menu"
        @click="toggleNavbarMenu"
      >
        <span aria-hidden="true" />
        <span aria-hidden="true" />
        <span aria-hidden="true" />
      </a>
    </div>

    <div
      id="navbar-menu"
      class="navbar-menu"
      :class="navbarMenuIsActive"
    >
      <AppMenu class="navbar-start" />
      <div class="navbar-end">
        <span class="navbar-item is-flex is-centered">
          <RouterLink
            class="button is-danger is-outlined"
            active-class="is-active"
            :to="{ name: 'SignOut' }"
          >
            <BIcon icon="exit-to-app" />
          </RouterLink>
        </span>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'TheNavbar',
  components: {
    AppMenu: () => import(/* webpackChunkName: "super-admin-menu" */ '@/components/SuperAdmin/AppMenu.vue'),
  },
  data() {
    return {
      navbarMenu: false,
    };
  },
  computed: {
    navbarMenuIsActive() { return { 'is-active': this.navbarMenu }; },
  },
  watch: {
    $route() {
      this.navbarMenu = false;
    },
  },
  methods: {
    toggleNavbarMenu() { this.navbarMenu = !this.navbarMenu; },
  },
};
</script>

<style scoped>
img.logo  {
  height: 48px;
  width: auto;
}

h1 {
  padding-left: .5rem;
}

.navbar.has-shadow {
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, .25);
}

@media screen and (max-width: 768px) {
  .navbar-item {
    display: flex;
    justify-content: flex-end;
  }
}

@media screen and (max-width: 1087px) {
  .navbar-end {
    padding-top: 1rem;
  }

  .title.is-4 {
    color: whitesmoke;
  }
}

@media screen and (min-width: 1088px) {
  .navbar-start {
    display: none;
  }


  .navbar.is-primary .navbar-brand > a.navbar-item:hover {
    background-color: rgba(0, 0, 0, .1);
  }
}
</style>

<style>
.admin.hero.is-primary .navbar-item:hover {
  background-color: transparent;
}

@media screen and (max-width: 768px) {
  .admin.hero .navbar.is-primary.is-fixed-top,
  .admin.hero .navbar.is-primary.is-fixed-top .navbar-menu {
    background-color: #39455B;
  }
}

@media screen and (max-width: 1087px) {
  .admin.hero .navbar.is-primary.is-fixed-top,
  .admin.hero .navbar.is-primary.is-fixed-top .navbar-menu {
    background-color: #39455B;
  }
}

@media screen and (min-width: 1088px) {
  .admin.hero .navbar.is-primary.is-fixed-top,
  .admin.hero .navbar.is-primary.is-fixed-top .navbar-menu {
    background-color: whitesmoke;
  }
}
</style>
